import { createSelector } from 'reselect';

import { filtersSelector } from '../root/filtersSelector';

export const geoSelector = createSelector(filtersSelector, filters => filters.geo);
